<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">
        合约资金流水
        <TopPartner @refreshTopPartner="handleSearch"></TopPartner>
      </div>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input placeholder="顶级合伙人UID" clearable v-model="topUserId" class="userUid_ipt" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input placeholder="用户UID" clearable v-model="userId" class="userUid_ipt" size="mini">
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">邀请人UID</div> -->
            <div class="ipt">
              <el-input placeholder="仓位ID" size="mini" clearable v-model="positionId">
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="channelUserId" class="userUid_ipt" size="mini">
                <!-- <img :src="channel" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input placeholder="订单ID" clearable v-model="bizId" class="userUid_ipt" size="mini">
                <!-- <img :src="channel" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select size="mini" @change="changeCoin" :rules="[
                { required: true, message: '请选择', trigger: 'change' },
              ]" v-model="billType" placeholder="请选择">
                <el-option label="全部类型" value=""> </el-option>
                <el-option v-for="item in billTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select size="mini" @change="changeCoinType" v-model="coin" placeholder="请选择">
                <el-option label="全部币种" value=""> </el-option>
                <el-option v-for="item in coinList" :key="item.id || item.coin || item"
                  :label="(item.coin || '').toUpperCase()" :value="item.coin || item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">注册日期</div> -->
            <div class="ipt">
              <el-date-picker v-model="value1" size="mini" type="daterange" align="right" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" unlink-panels range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期" @change="changeTime($event)" :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <div class="item-sle">
              <div class="tit">用户范围</div>
              <el-select size="mini" v-model="type" placeholder="用户范围">
                <el-option v-for="item in [
                  { id: 1, value: '隐藏（仅普通用户）' },
                  { id: 2, value: '显示（普通+模拟+特殊）' },
                ]" :key="item.id" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="item-sle">
              <div class="tit">账户类型</div>
              <el-select size="mini" v-model="balanceType" placeholder="账户类型">
                <el-option label="全部类型" value=""></el-option>
                <el-option label="合约" :value="1"></el-option>
                <el-option label="跟单" :value="8"></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import userUid from "@/assets/input/userUid.png";
import invite from "@/assets/input/invite.png";
import channel from "@/assets/input/channel.png";
import TopPartner from "../topPartner";
import moment from "moment";
export default {
  name: "contractBill",
  components: {
    UserList,
    TopPartner,
  },
  data() {
    return {
      invite,
      channel,
      userUid,
      value2: "",
      type: 1,
      dialogVisible: false,
      topUserId: "",
      userId: "",
      channelId: "",
      bizId: "",
      channelUserId: "",
      positionId: "",
      billType: "",
      coin: "",
      value1: "",
      balanceType: "",
      // value1: [
      // moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      billTypeOptions: [
        { value: 1, label: "划转" },
        { value: 2, label: "平仓交易盈亏" },
        { value: 3, label: "仓位接管" },
        { value: 4, label: "强平清算费" },
        { value: 5, label: "资金费用" },
        { value: 6, label: "手续费 (开仓、平仓、强平)" },
        { value: 7, label: "自动减仓" },
        { value: 8, label: "虚增" },
        { value: 9, label: "双向仓位合并" },
        { value: 10, label: "系统平仓" },
        { value: 11, label: "返现" },
        { value: 12, label: "推荐人返佣" },
        { value: 13, label: "抵扣金抵扣" },
        { value: 14, label: "抵扣金发放" },
        { value: 15, label: "抵扣金回收" },
        { value: 16, label: "赠币" },
        { value: 301, label: "交易员分润" },
        { value: 302, label: "跟单员分润扣除" },
        { value: 303, label: "跟单员分润返还" },
        { value: 401, label: "体验金发放" },
        { value: 403, label: "体验金回收" },
        { value: 404, label: "体验金手续费抵扣" },
        { value: 405, label: "体验金资金费抵扣" },
        { value: 406, label: "体验金盈亏抵扣" },
        { value: 411, label: "仓位体验券盈利" },
        { value: 412, label: "手续费抵扣券发放" },
        { value: 413, label: "手续费抵扣券回收" },
        { value: 414, label: "盈亏抵扣券发放" },
        { value: 415, label: "盈亏抵扣券回收" },
        { value: 416, label: "异常资产扣除" },
      ],
    };
  },
  computed: {
    ...mapState("contractBill", ["queryType", "queryTypeList", "pagination"]),
    ...mapState("contractBill", ["coinList"]),
    ...mapState(["userInfo"]),
    ...mapState("topPartner", ["topPartner"]),
  },
  methods: {
    ...mapActions("contractBill", ["list", "addUser", "exportExcel", "getCoinList"]),
    ...mapMutations("contractBill", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        topUserId: this.topUserId || this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,
        bizId: this.bizId,
        billType: this.billType,
        coin: this.coin,
        type: this.type,
        balanceType: this.balanceType,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...this.pagination,
        ...data,
      });
    },
    getExcel() {
      this.exportExcel({
        topUserId: this.topUserId || this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,
        bizId: this.bizId,
        billType: this.billType,
        coin: this.coin,
        type: this.type,
        balanceType: this.balanceType,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...this.pagination,
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" }); //设置文件流
        link.style.display = "none";
        // 设置连接
        link.href = URL.createObjectURL(blob); //将文件流转化为blob地址
        console.log("link-href", link.href);
        link.download = "合约资金流水";
        document.body.appendChild(link);
        // 模拟点击事件
        link.click(); //设置点击事件
      });
    },
    changeCoin(e) {
      this.billType = e;
      this.list({
        topUserId: this.topUserId || this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,
        bizId: this.bizId,
        billType: e,
        coin: this.coin,
        type: this.type,
        balanceType: this.balanceType,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    changeCoinType(e) {
      this.coin = e;
      this.handleSearch();
    },
    changeTime(e) {
      this.list({
        topUserId: this.topUserId || this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,
        bizId: this.bizId,
        billType: this.billType,
        coin: this.coin,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() - 1),
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() - 1),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(),
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        topUserId: this.topUserId || this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,
        bizId: this.bizId,
        billType: this.billType,
        coin: this.coin,
        type: this.type,
        balanceType: this.balanceType,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    handleSave() { },
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() { },
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  created() {
    this.getCoinList({ type: "CONTRACT" });
    this.list({
      topUserId: this.topUserId || this.topPartner,
      channelUserId: this.channelUserId,
      userId: this.userId,
      positionId: this.positionId,
      bizId: this.bizId,
      billType: this.billType,
      coin: this.coin,
      type: this.type,
      balanceType: this.balanceType,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
